import React, { useState, useRef, useEffect } from "react"
import styles from "../../styles/opener.module.scss"
import Parallax from "./Parallax"
import Sizing from "./Sizing"

import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Opener = ({ pageName, children, titles }) => {
    const data = useStaticQuery(graphql`
        query {
            diseasePhoto: file(
                relativePath: { eq: "disease/opener-photo.png" }
            ) {
                childImageSharp {
                    fluid(maxWidth: 2560) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                    }
                }
            }
            climatePhoto: file(
                relativePath: { eq: "climate/opener-photo.png" }
            ) {
                childImageSharp {
                    fluid(maxWidth: 2560) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                    }
                }
            }
            hungerPhoto: file(relativePath: { eq: "hunger/opener-photo.png" }) {
                childImageSharp {
                    fluid(maxWidth: 2560) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                    }
                }
            }
            rentsPhoto: file(relativePath: { eq: "rents/opener-photo.png" }) {
                childImageSharp {
                    fluid(maxWidth: 2560) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                    }
                }
            }
            racismPhoto: file(relativePath: { eq: "racism/opener-photo.png" }) {
                childImageSharp {
                    fluid(maxWidth: 2560) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                    }
                }
            }
            boredomPhoto: file(
                relativePath: { eq: "boredom/opener-photo.png" }
            ) {
                childImageSharp {
                    fluid(maxWidth: 2560) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                    }
                }
            }
        }
    `)

    function getClass(className) {
        return styles[className] + " " + styles[`${className}_${pageName}`]
    }

    return (
        <>
            {" "}
            <div className={styles.wrap}>
                <div className={styles.headerPadding}></div>
                <div className={getClass("main")}>
                    <div className={getClass("grain")}></div>
                    <div className={getClass("texture")}></div>

                    <div className={getClass("image")}>
                        <Img
                            className={styles.image}
                            style={{ width: "100%" }}
                            fluid={
                                data[pageName + "Photo"].childImageSharp.fluid
                            }
                        />
                    </div>
                    <Parallax
                        movement={-0.1}
                        pStyle={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            top: 0,
                            left: 0,
                        }}
                        cStyle={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            top: 0,
                            left: 0,
                        }}
                    >
                        <div
                            className={getClass("motif") + " " + styles.motif1}
                        >
                            {children}
                        </div>
                    </Parallax>
                    <div className={getClass("title")}>
                        <Sizing
                            breaks={[
                                {
                                    min: 0,
                                    val: {
                                        width: titles[1].size,
                                        marginLeft: (24 - titles[1].size) / 2,
                                        marginTop: 2,
                                    },
                                },

                                {
                                    min: 768,
                                    val: {
                                        width: titles[1].size - 2,
                                        marginLeft:
                                            (24 - (titles[1].size - 2)) / 2,
                                        marginTop: 2,
                                    },
                                },

                                {
                                    min: 1024,
                                    val: {
                                        width: titles[0].size,
                                        marginLeft: (24 - titles[0].size) / 2,
                                        marginTop: 2,
                                    },
                                },
                            ]}
                        >
                            <img
                                className={styles.titleLrg}
                                src={titles[0].img}
                                alt=""
                            />
                            <img
                                className={styles.titleSml}
                                src={titles[1].img}
                                alt=""
                            />
                        </Sizing>
                    </div>
                    <div className={getClass("wave")}>
                        <svg
                            data-name="Layer 1"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1200 120"
                            preserveAspectRatio="none"
                        >
                            <path
                                d="M321.39 56.44c58-10.79 114.16-30.13 172-41.86 82.39-16.72 168.19-17.73 250.45-.39C823.78 31 906.67 72 985.66 92.83c70.05 18.48 146.53 26.09 214.34 3V0H0v27.35a600.21 600.21 0 00321.39 29.09z"
                                fill="white"
                            ></path>
                        </svg>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Opener
